import { merge } from 'lodash';
import dayjs from 'dayjs';
import 'dayjs/locale/zh';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import { elementEnLocale } from 'zk-ui'; // zk-ui lang
import { elementZhLocale } from 'zk-ui';// zk-ui lang

dayjs.extend(localizedFormat);
const files = require.context('./locales', true, /\.js$/);
export const locales = [];

const messages = files.keys().map(key => key.split('/')).filter(paths => paths.length === 3).reduce((acc, c) => {
  const fileName = c[2].replace('.js', '');
  const locale = c[1];
  const message = files(c.join('/')).default;
  locales.push(locale);
  if (fileName === 'index') {
    return {
      ...acc,
      [locale]: merge({}, acc[locale], message)
    };
  }
  return {
    ...acc,
    [locale]: merge({}, acc[locale], { [fileName]: message })
  };
}, {
  zh: {
    ...elementZhLocale
  },
  en: {
    ...elementEnLocale
  }
});

export default messages;
